import { useEffect } from "react";
import { useMediaQuery } from "./hooks/useMediaQuery";
import { useUiStore } from "./state/uiStore";
import { applyBrandColor } from "./lib/brand";
import { MobileShell } from "./components/shells/MobileShell";
import { DesktopShell } from "./components/shells/DesktopShell";
import { TweaksPanel } from "./components/dev/TweaksPanel";
import { useRealtimeSync } from "./lib/realtime";

export function App() {
  useRealtimeSync();
  const isDesktop = useMediaQuery("(min-width: 900px)");
  const brand = useUiStore((s) => s.brand);

  useEffect(() => {
    applyBrandColor(brand);
  }, [brand]);

  return (
    <>
      {isDesktop ? <DesktopShell /> : <MobileShell />}
      {import.meta.env.DEV && <TweaksPanel />}
    </>
  );
}
